import { z } from 'zod';

export const AvailabilitySchema = z.enum(['in_stock', 'preorder', 'out_of_stock']);
export type Availability = z.infer<typeof AvailabilitySchema>;

export const AVAILABILITY_LABELS: Record<Availability, string> = {
  in_stock: 'В наличии',
  preorder: 'Предзаказ',
  out_of_stock: 'Нет в наличии',
};
